import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import {GET} from '../helpers'
import {TOKEN, GET_USER_URL, CART} from '../vars'
import {setLocalKeyValue, getLocalKeyValue} from '../storage'

class Team extends React.Component {



  static async getInitialProps(props) {
    let token =  await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

    let infoRequest, infoResponse={}
    if(token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }

    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
    }
  }

  render() {

    return <LayoutBasic title="Picxy Team" {...this.props} defaultNavBar={true}>
      <div className="container font-small mt-5">
        <div className='row'>
          <div>
        <h3>"Thank you for visiting! We are currently working on bringing you the latest information and content for this page. Please check back soon for updates. We apologize for any inconvenience and appreciate your patience."</h3>
        </div>
</div>
        {/* <h1 className=" font-weight-light">Meet The Team</h1> */}
        {/* <div className="row">
          <div className="col-sm-4 col-6">
            <div className="feature-8">
              <img src="/static/img/team/jit.png" className="rounded-circle d-block mx-auto img-fluid" alt="jitendra Photo" />
              <div className="text-block text-center">
                <h3>Jitendra Emmani</h3>
                <span className="text-muted">CEO &amp; Co-Founder</span>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-6">
            <div className="feature-8">
              <img src="/static/img/team/vamsi.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="Vamsi Photo" />
              <div className="text-block text-center">
                <h3>Vamsi Mannem</h3>
                <span className="text-muted">CTO &amp; Co-Founder</span>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-6">
            <div className="feature-8">
              <img src="/static/img/team/satish.png" className="rounded-circle d-block mx-auto img-fluid" alt="satish Photo" />
              <div className="text-block text-center">
                <h3>Satish V Madala</h3>
                <span className="text-muted">COO &amp; Co-Founder</span>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-6 d-none">
            <div className="feature-8">
              <img src="/static/img/team/prudhvi.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="prudhvi Photo" />
              <div className="text-block text-center">
                <h3>Prudhvi Chowdary</h3>
                <span className="text-muted">Head of Operations(Photography)</span>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-6 d-none">
            <div className="feature-8">
              <img src="/static/img/team/munna.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="munna Photo" />
              <div className="text-block text-center">
                <h3>Abdul Munaff</h3>
                <span className="text-muted">Photographer Relations Manager</span>
              </div>
            </div>
          </div>

          <div className="col-sm-2 col-6 d-none">
            <div className=" feature feature-8">
              <img src="/static/img/team/prakash.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="prakash Photo" />
              <div className="text-block text-center">
                <h3>Prakash VS</h3>
                <span className="text-muted">Tech Lead</span>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-6 d-none">
            <div className=" feature feature-8">
              <img src="/static/img/team/rajesh.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="rajesh Photo" />
              <div className="text-block text-center">
                <h3>Rajesh Kumar</h3>
                <span className="text-muted">Software Developer</span>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-6 d-none">
            <div className=" feature feature-8">
              <img src="/static/img/team/akshay.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="akshay Photo" />
              <div className="text-block text-center">
                <h3>Akshay Agnihotri</h3>
                <span className="text-muted">UX/UI Designer</span>
              </div>
            </div>
          </div>
          <div className="col-sm-2 col-6 d-none">
            <div className=" feature feature-8">
              <img src="/static/img/team/vijay.jpg" className="rounded-circle d-block mx-auto img-fluid" alt="pushpendra Photo" />
              <div className="text-block text-center">
                <h3>Vijaydeep Sarikonda</h3>
                <span className="text-muted">Executive (F&A, HR) </span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </LayoutBasic>
  }
}

export default withRouter(Team)
